'use client';

import { Ship } from 'lucide-react';

interface Props {
  className?: string;
}

export default function BoatImagePlaceholder({ className = '' }: Props) {
  return (
    <div
      className={`flex items-center justify-center bg-slate-100 text-slate-300 ${className}`}
    >
      <Ship className="w-12 h-12" strokeWidth={1.2} />
    </div>
  );
}
